<template>
  <div>
<!--    <el-button type="primary" @click="handleAdd">新增</el-button>-->

    <el-form>
      <el-form-item label="所属仓库">
        <WarehouseLov width="300px" :value="warehouseId" @callBack="setWarehouse"/>
        <el-button type="primary" @click="fetchData">查询</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="tableDataShow" style="width: 100%" border>
      <el-table-column type="index" label="序号" width="80"/>
      <el-table-column prop="name" label="物料名称" width="500">
        <template slot="header" slot-scope="scope">
          <ScreenTableHeader
              :key="scope.column.property"
              :ref="`ScreenTable${scope.column.property}`"
              :header-scope="scope"
              condition-type="list"
              :search-list="searchData"
              @screenChange="screenChange"
          />
        </template>
      </el-table-column>
      <el-table-column prop="typeName" label="物料类型"width="400">
        <template slot="header" slot-scope="scope">
          <ScreenTableHeader
              :key="scope.column.property"
              :ref="`ScreenTable${scope.column.property}`"
              :header-scope="scope"
              condition-type="list"
              :search-list="searchData"
              @screenChange="screenChange"
          />
        </template>
      </el-table-column>
      <el-table-column prop="num" label="数量"width="200"/>
      <el-table-column prop="warehouseName" label="所属仓库"/>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button size="mini" @click="dialogVisible = true,form = scope.row">查看详情</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog
        fullscreen
        destroy-on-close
        :title="form.name+` 流转详情`"
        :visible.sync="dialogVisible">
      <!--      <img :src="packageUrl">-->
      <el-tabs v-model="dialogActiveName" v-if="dialogVisible" type="card">
        <el-tab-pane label="库存详情" name="MaterialItemLine">
          <MaterialItemLine :id="form.id"/>
        </el-tab-pane>
        <el-tab-pane label="库存流水" name="MaterialItemDetails">
          <MaterialItemDetails :id="form.id"/>
        </el-tab-pane>
      </el-tabs>
    </el-dialog>
  </div>
</template>

<script>
import requestTicket from '@/utils/requestTicket';
import MaterialItemLine from "@/views/ticket/MaterialItemLine.vue";
import MaterialItemDetails from "@/views/ticket/MaterialItemDetails.vue";
import WarehouseLov from "@/views/ticket/lov/WarehouseLov.vue";
import ScreenTableHeader from "@/views/element/ScreenTableHeader.vue";

export default {
  components: {ScreenTableHeader, MaterialItemLine,MaterialItemDetails,WarehouseLov},
  data() {
    return {
      tableData: [],
      tableDataShow: [],
      // 添加分页参数
      currentPage: 1,
      pageSize: 10,
      total: 0,
      dialogVisible: false,
      bomDialogVisible: false,
      dialogTitle: '',
      currentMaterialId: null,
      form: {
        id: null,
        name: '',
        material_type: ''
      },
      warehouseId: null,
      dialogActiveName: 'MaterialItemLine'
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    // 查询数据
    async fetchData() {
      try {
        const response = await requestTicket.post('/Ticketing/procedure/execute', {
          procedureName: "get_material_with_num",
          parameters: [this.warehouseId ? this.warehouseId : null]
        });
        this.tableData = response.data;
        this.tableDataShow = response.data;
        this.total = response.data.total; // 假设返回总记录数在totalElements字段
      } catch (error) {
        console.error('获取数据失败:', error);
      }
    },

    // 添加分页事件处理方法
    handleSizeChange(val) {
      this.pageSize = val;
      this.fetchData();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.fetchData();
    },
    setWarehouse(item){
      this.warehouseId = item?.id
    },
    searchData(){
      return this.tableData
    },
    screenChange(conditionType, screen,prop) {
      this.tableDataShow = this.tableData.filter(item => {
        if (conditionType === 'txt') {
          if (screen) {
            return item[prop()].includes(screen);
          } else {
            return true;
          }
        } else if (conditionType === 'list') {
          if (screen.length) {
            return screen.includes(item[prop()]);
          } else {
            return true;
          }
        } else if (conditionType === 'date' || conditionType === 'scope' || conditionType === 'datetime') {
          if (screen) {
            return item[prop()] >= screen[0] && item[prop()] <= screen[1];
          } else {
            return true;
          }
        }
      });
    }
  }
};
</script>

<style scoped>
.el-button {
  margin-bottom: 15px;
  margin-right: 10px;
}
</style>